module.exports = __webpack_public_path__ + "static/media/logo.cfc8586a.png";